export default ({driver: {dmv_license_number = ''} = {}} = {}) =>
  dmv_license_number;
